export const getApi = (): string => {
	return 'https://api.badger.com/v2';
};
export const BADGER_API = getApi();
